import React from 'react';
import './Popup.css';

const Popup = ({ message, onClose, type = 'info' }) => {
  return (
    <div className="popup-overlay">
      <div className={`popup-content ${type}`}>
        <div className="popup-message">{message}</div>
        <button className="popup-close" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

export default Popup; 